import i18n from 'i18next'
import { observable, autorun, makeObservable } from 'mobx'

class QuestionCategoryStore {
    @observable loading = true

    @observable filteredList = []

    @observable showModal = false

    categories = []

    category = {
        description: '',
        sort: 0,
    }

    questions = []

    @observable formFields = []

    @observable formLoading = true

    constructor(appStore) {
        makeObservable(this)
        this.appStore = appStore

        autorun(() => {
            if (this.formFields.length > 0) this.formLoading = false
        })
    }

    initSearch = async () => {
        try {
            await this.getCategories()
        } catch (error) {
            console.log('QuestionCategoryStore initSearch error ', error)
            // this.appStore.addNotification(null, 'Failed to connect with server', 'error')
        }
    }

    getCategories = async () => {
        try {
            const categories = await this.appStore.http.get('/questioncategory/categories?isGlobal=1')
            this.categories = categories
            this.filter()
        } catch (error) {
            console.log('QuestionCategoryStore getCategories error ', error)
        }
    }

    initQuestionCategory = async (categoryId, handleCloseModal) => {
        if (categoryId === 0) {
            this.defineFormFields(this.category)
            return
        }

        const foundCategory = this.categories.find(
            (category) => (category.categoryId === categoryId),
        )
        this.questions = await this.fetchQuestions(categoryId)
        console.log('>> found c ', foundCategory, this.questions)
        if (foundCategory) {
            this.category = foundCategory
            this.defineFormFields(this.category)
        } else {
            handleCloseModal()
            // this.appStore.addNotification(null, 'Failed to connect with server', 'error')
        }
    }

    defineFormFields = (category) => {
        this.formFields = [
            {
                type: 'input',
                name: 'description',
                label: i18n.t('questionCategory.form.description', 'Description'),
                placeholder: i18n.t('questionCategory.form.description', 'Description'),
                defaultValue: category.description,
                isMandatory: true,
                errorMessage: i18n.t('questionCategory.form.error.description'),
            },
            {
                type: 'input',
                inputType: 'number',
                name: 'sort',
                label: i18n.t('questionCategory.form.sort', 'Sort weighting'),
                placeholder: i18n.t('questionCategory.form.sort', 'Sort weighting'),
                defaultValue: category.sort,
                isMandatory: true,
                errorMessage: i18n.t('questionCategory.form.error.sort'),
                min: '0',
            },
        ]
    }

    setField = async ({ value, name }) => {
        console.log(`setField ${value} => ${name}`)
        this.category[name] = value
    }

    resetFormState = () => {
        this.formFields = []
        this.category = {
            description: '',
            sort: 0,
        }
        this.questions = []
    }

    fetchQuestions = (categoryId) => this.appStore.http.get(`/questioncategory/${categoryId}/questions`)

    updateCategry = async (categoryId, handleCloseModal) => {
        try {
            await this.appStore.http.put(`/questioncategory/${categoryId}`, JSON.stringify(this.category))
            handleCloseModal()
            await this.getCategories()
            // this.appStore.addNotification(null, 'Category updated', 'success')
        } catch (e) {
            handleCloseModal()
            // this.appStore.addNotification(null, e.message, 'error')
        }
    }

    createCategory = async (categoryId, handleCloseModal) => {
        try {
            await this.appStore.http.post(`/questioncategory/${categoryId}`, JSON.stringify(this.category))
            handleCloseModal()
            await this.getCategories()
            // this.appStore.addNotification(null, 'Category created', 'success')
        } catch (e) {
            handleCloseModal()
            // this.appStore.addNotification(null, e.message, 'error')
        }
    }

    onSearch = () => {
        console.log('onSearch ' + this.searchModule.searchStr)
        this.filter(this.searchModule.searchStr)
    }

    filter = (searchStr) => {
        if (searchStr) {
            const regExp = new RegExp(searchStr, 'gi')
            this.filteredList = this.filteredList.filter(
                (category) => category.description.match(regExp),
            )
        } else {
            this.filteredList = this.categories
        }
    }
}

export default QuestionCategoryStore
